import { Component, computed, input, signal } from "@angular/core";

import { extractSerialNumber, serialNumberPatternError } from "../../../_helpers/serial-number-pattern";

// „Scan testen" fürs SN-Muster der Artikelvorlage (bentomax/hawk#611):
// Beispiel-Scan eingeben, live sehen, welche SN die App herausziehen würde.
@Component({
  selector: "hawk-serial-number-pattern-tester",
  standalone: true,
  templateUrl: "./serial-number-pattern-tester.component.html",
})
export class SerialNumberPatternTesterComponent {
  pattern = input<string | null>(null);

  protected scan = signal("");

  /** Ergebnis für die Anzeige; `null`, solange nichts zu zeigen ist */
  protected result = computed<{ serialNumber: string | null } | null>(() => {
    const scan = this.scan();
    const pattern = this.pattern();
    if (!scan || !pattern || serialNumberPatternError(pattern)) return null;
    return { serialNumber: extractSerialNumber(scan, pattern) };
  });

  protected onScanInput(event: Event) {
    this.scan.set((event.target as HTMLInputElement).value);
  }
}
